import axiosInstance from "../../../../../axiosInstance";
import {
  success,
  error,
  info,
  warning,
} from "../../../../../store/notification/actions";

export async function addSaleableReturnsStage(data) {
  info("Scanning Saleable Returns ...");
  if (data != null) {
    return await axiosInstance
      .post("/inventory/addSaleableReturnsStage", {
        user_id: data.userId,
        store_id: data.storeId,
        tote_number: data.tote_number,
        supplier: data.selectedSupplier.optionname,
        supplier_id: data.selectedSupplier.id,
        ra_number: data.ra_number,
        barcode: data.barcode,
        confirm_duplicate_ra: data.confirmRepeatRA || false,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Saleable Returns Added Successfully");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function editSaleableReturnsStage(data) {
  info("Saving Saleable Returns ...");

  if (data != null) {
    return await axiosInstance
      .post("/inventory/editSaleableReturnsStage", {
        user_id: data.userId,
        store_id: data.storeId,
        tote_number: data.tote_number,
        supplier: data.selectedSupplier.optionname,
        supplier_id: data.selectedSupplier.id,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Saleable Return Saved Successfully");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function deleteSaleableReturnsStage(data) {
  info("Deleting Saleable Returns ...");
  if (data != null) {
    return await axiosInstance
      .post("/inventory/deleteSaleableReturnsStage", {
        user_id: data.userId,
        store_id: data.storeId,
        ndc: data.ndc,
        lot: data.lot,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Removed Saleable Returns Successfully!!!");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function getSaleableReturnsStage(data) {
  info("Loading Saleable Returns ...");

  if (data != null) {
    return await axiosInstance
      .post("/inventory/getSaleableReturnsStage", {
        user_id: data.userId,
        store_id: data.storeId,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Saleable Returns Loaded Successfully!!!");
        } else {
          warning("No records found !!!");
        }
        return response.data.data;
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function addSaleableReturnsCurrent(data) {
  info("Adding to Reconcile...");
  if (data != null) {
    return await axiosInstance
      .post("/inventory/addSaleableReturnsCurrent", {
        user_id: data.userId,
        store_id: data.storeId,
        tote_number: data.tote_number,
        ra_number: data.ra_number,
        supplier: data.selectedSupplier.optionname,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Added to Reconcile Successfully");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

// Update comments against ndc in saleable return table
export async function UpdateCommentsSaleableReturn(data) {
  info("Updating Comment...");
  if (data != null) {
    if (!data.comment) {
      error("Comment should not be empty");
      return;
    }
    return await axiosInstance
      .post("/inventory/updateCommentsSaleableReturn", {
        user_id: data.user_id,
        store_id: data.store_id,
        ndc: data.ndc,
        comment: data.comment,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success(response.data.data[0].message);
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

// get comments for a NDC from saleable return table
export async function GetCommentsSaleableReturn(data) {
  info("Loading Comment..");
  if (data != null) {
    return await axiosInstance
      .post("/inventory/getCommentsSaleableReturn", {
        user_id: data.user_id,
        store_id: data.store_id,
        ndc: data.ndc,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Loaded Comments");
          return response.data.data;
        } else {
          success("No comments Found. Add New");
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

// Truncating Saleable Return stage table
export async function truncateSaleableReturnStage(data) {
  if (data) {
    return await axiosInstance
      .post("/inventory/truncateSaleableReturnStage", {
        user_id: data.user_id,
        store_id: data.store_id,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("New session created Successfully");
          if (response.data.data && response.data.data.length > 0) {
            return response.data.data;
          } else {
            return [];
          }
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}
